// Hook to determine if the Home page data is still loading
import { useEffect, useState } from 'react'
import useStore from '../store/useStore'

/**
 * A hook that determines if the Home page data is still loading
 * by checking if critical data has been loaded into the store.
 */
const useIsHomeLoading = (): boolean => {
  const [isLoading, setIsLoading] = useState(true)
  const firestoreUser = useStore((s) => s.firestoreUser)
  const content = useStore((s) => s.content)
  const meta = useStore((s) => s.meta)

  useEffect(() => {
    // We consider the page loaded when we have the user data, content and meta info
    // or after a 2-second timeout (to prevent infinite loading on errors)
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 2000)

    // If we have all the data we need, set loading to false
    if (
      firestoreUser !== undefined &&
      content !== undefined &&
      meta !== undefined
    ) {
      setIsLoading(false)
      clearTimeout(timer)
    }

    return () => {
      clearTimeout(timer)
    }
  }, [firestoreUser, content, meta])

  return isLoading
}

export default useIsHomeLoading
